import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Layout";
import Container from "../../components/Container/Container";
import Modal from "../../components/UI/Modal/Modal";
import EmployeeTable from "./EmployeeTable";
import { GetEmployeeList, GetDepartments } from "../../ApiCalls";

const EmployeeListPage = () => {
  const [employees, setEmployees] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState(null);

  const openModal = (title, content) => {
    setModalOpen(true);
    setModalTitle(title);
    setModalContent(content);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalContent(null);
    setModalTitle("");
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchEmployees();
      await fetchDepartments();
    };
    fetchData();
  }, []);

  const fetchEmployees = async () => {
    try {
      const response = await GetEmployeeList();
      if (response.data?.success) {
        setEmployees(response.data.employeeList);
      }
    } catch (error) {
      console.error("Failed to load employees:", error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await GetDepartments();
      if (response.data?.success) {
        setDepartments(response.data.departmentList);
      }
    } catch (error) {
      console.error("Failed to load departments:", error);
    }
  };

  return (
    <>
      <Layout />
      <Container>
        <h2>Employee List</h2>
        <EmployeeTable
          employees={employees}
          openModal={openModal}
          closeModal={closeModal}
          setEmployees={setEmployees}
        />
        <Modal value={modalOpen} parentClose={closeModal} title={modalTitle}>
          {modalContent}
        </Modal>
      </Container>
    </>
  );
};

export default EmployeeListPage;
